import React from 'react';
import { useLanguage } from '../../context/LanguageContext';

const LanguageToggle = () => {
  const { language, toggleLanguage } = useLanguage();

  return (
    <button
      onClick={toggleLanguage}
      className="flex items-center gap-1 px-3 py-1.5 border border-[rgba(91,122,138,0.3)] rounded-full text-[#9AACB8] hover:text-white hover:border-[#5B7A8A] transition-colors text-sm font-medium"
      data-testid="language-toggle"
    >
      <span className={language === 'en' ? 'text-white' : ''}>EN</span>
      <span>/</span>
      <span className={language === 'fr' ? 'text-white' : ''}>FR</span>
    </button>
  );
};

export default LanguageToggle;
